import { useSellableGames } from "@/hooks/useBhapticsContents";
import { useCurrency } from "@/hooks/useCurrency";
import { useProducts } from "@/services/product/useProductService";
import { ProductUtil } from "@/utils/ProductUtil";
import { useMemo } from "react";
import { usePricedFilter } from "@/hooks/usePricedFilter";

export const useValidBundles = () => {
  const sellableGames = useSellableGames({ inStockOnly: true });
  const currency = useCurrency();
  const { data: products } = useProducts();
  // 판매 목록 — 이 국가·통화에서 가격 없는 번들은 뺀다(`usePricedFilter`).
  const priced = usePricedFilter();

  const validBundles = useMemo(() => {
    if (!products) return [];

    const allBundles = ProductUtil.getAllBundles(products || []);
    return priced(
      ProductUtil.getValidBundles({
        bundles: allBundles,
        // 번들 전용 게임 키 포함 목록(#6053) — `gameResells` 는 단독 판매 가능분만이라 그 번들이 빠진다
        gameResells: sellableGames.bundleGameResells,
        currency,
      }),
    );
  }, [products, currency, sellableGames.bundleGameResells, priced]);

  return validBundles;
};
